import React, { useCallback, useState } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import { useFolderGridCellDropStyle } from '../styles/tiles-grid-cell-drop-decorator-style';

export const TilesGridCellDropDecorator = ({
  children,
  droppable,
  onDrop,
  customClassName,
}) => {
  const [isOver, setIsOver] = useState(false);

  const tilesGridCellDropOver = useFolderGridCellDropStyle();

  const onDragOver = useCallback((event) => {
    event.preventDefault();
    setIsOver(true);
  }, []);

  const onDragLeave = useCallback(() => {
    setIsOver(false);
  }, []);

  const onDropHandler = useCallback((event) => {
    event.preventDefault();
    setIsOver(false);
    onDrop();
  }, [onDrop]);

  return (
    droppable ? (
      <div
        onDragOver={onDragOver}
        onDragLeave={onDragLeave}
        onDrop={onDropHandler}
        className={classNames('dropZone', isOver ? (customClassName || tilesGridCellDropOver) : '')}
      >
        {children}
      </div>
    ) : children
  );
};

TilesGridCellDropDecorator.propTypes = {
  children: PropTypes.node.isRequired,
  droppable: PropTypes.bool,
  onDrop: PropTypes.func,
  customClassName: PropTypes.string,
};

TilesGridCellDropDecorator.defaultProps = {
  droppable: false,
  onDrop: () => null,
  customClassName: '',
};
